import withDelayedHoverEvent from "app/pages/sales-intelligence/hoc/withDelayedHoverEvent";
import withMouseEventHandlers from "app/pages/sales-intelligence/hoc/withMouseEventHandlers";
import type { CellProps } from "app/pages/sales-intelligence/pages/home/types/table";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";
import type { ComponentType, MouseEventHandler, ReactElement } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type HocProps = {
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
};

const withTrackedRedirectCell = <R,>(CellComponent: ComponentType<CellProps<R> & HocProps>) => {
    const ComponentWithDelayedHoverEvent = withDelayedHoverEvent(withMouseEventHandlers(CellComponent));

    return function WrappedWithTrackedRedirectCell(props: CellProps<R>): ReactElement {
        const navigationParams = props.metadata.getNavigationParams(props);

        const handleClick = (): void => {
            homePageTrackingService.table.trackRedirectToPageFromTableClicked(props.metadata.trackingCategory, props);
            proNavigator.go(...navigationParams);
        };

        const handleMouseEnter = (): void => {
            homePageTrackingService.table.trackRedirectToPageFromTableHovered(props.metadata.trackingCategory, props);
        };

        return (
            <ComponentWithDelayedHoverEvent
                {...props}
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
            />
        );
    };
};

export default withTrackedRedirectCell;
